import { atom } from "recoil";

export const approvePopper = atom({
  key: "approvePopper",
  default: false,
});
